import { IBaseNotification, NotificationPopupType } from '../models/notification.model';

export const centerTypeSelector = (n: IBaseNotification): boolean => n.popupType === NotificationPopupType.NotificationCenter;

export const toastTypeSelector = (n: IBaseNotification): boolean => n.popupType === NotificationPopupType.Toast;
